export default __webpack_public_path__ + "f4164994a595fa2912f3dfed5872cf74.png";